import { FC, memo } from 'react';
import type { Dayjs } from 'dayjs';
import { Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './style.module.css';
import { PhoneInput } from '../../../../uikit/PhoneInput/PhoneInput';
import { RangeValue } from '../../../../hooks/components/useBlacklist/useBlacklistHandlers/types';
import { RANGE_PRESENT } from './constants';
import { ReasonTypes } from '../../../../hooks/components/useBlacklist/types';
import {
  REASONS,
  REASONS_MAP_TEXT,
} from '../../../../hooks/components/useBlacklist/useBlacklistColumns/constants';
import { ResettableRangePicker } from '../../../shared/ResettableRangePicker/ResettableRangePicker';
import type { ResettableRangePickerValue } from '../../../shared/ResettableRangePicker/ResettableRangePicker';

const CONTROL_FONT_SIZE = 14;

interface Props {
  searchValue: string;
  reasonValue: ReasonTypes | null;
  onReasonChange: (value: ReasonTypes | null) => void;
  onSearch: (digits: string) => void;
  onRangePickerChange: (
    values: RangeValue<Dayjs>,
    formatString: string[],
  ) => void;
  dateRange: ResettableRangePickerValue;
  disabled?: boolean;
}

const reasonOptions = REASONS.map((x: ReasonTypes) => ({
  value: x,
  label: REASONS_MAP_TEXT[x],
}));

export const BlacklistTableFilter: FC<Props> = memo(
  ({
    searchValue,
    reasonValue,
    onReasonChange,
    onSearch,
    onRangePickerChange,
    dateRange,
    disabled = false,
  }: Props) => {
    return (
      <div className={styles.filterBlock}>
        <PhoneInput
          allowClear
          className={styles.search}
          placeholder="Поиск по номеру телефона"
          prefix={<SearchOutlined className={styles.searchIcon} />}
          value={searchValue}
          onChange={onSearch}
          style={{ fontSize: CONTROL_FONT_SIZE }}
          disabled={disabled}
        />
        <ResettableRangePicker
          className={styles.dateInput}
          presets={RANGE_PRESENT}
          value={dateRange}
          onChange={onRangePickerChange}
          style={{ fontSize: CONTROL_FONT_SIZE }}
          disabled={disabled}
        />
        <Select
          allowClear
          className={styles.reason}
          placeholder="Причина блокировки"
          value={reasonValue}
          onChange={onReasonChange}
          removeIcon={null}
          options={reasonOptions}
          optionRender={(state) => (
            <span className={styles.inputSpan}>{state.label}</span>
          )}
          style={{ fontSize: CONTROL_FONT_SIZE }}
          disabled={disabled}
        />
      </div>
    );
  },
);

BlacklistTableFilter.displayName = 'BlacklistTableFilter';
